var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineTextBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.88 12.75c-.41 0-.75-.34-.75-.75V4.5c0-1.52 1.23-2.75 2.75-2.75H12c3.03 0 5.5 2.47 5.5 5.5s-2.47 5.5-5.5 5.5H4.88zm7.12-1.5c2.21 0 4-1.79 4-4s-1.79-4-4-4H6.88c-.69 0-1.25.56-1.25 1.25v6.75h-.01H12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.88 22.25c-1.52 0-2.75-1.23-2.75-2.75V12c0-.41.34-.75.75-.75h9.5c3.03 0 5.5 2.47 5.5 5.5s-2.47 5.5-5.5 5.5h-7.5zM5.62 19.5c0 .69.56 1.25 1.25 1.25h7.5c2.21 0 4-1.79 4-4s-1.79-4-4-4H5.62v6.75z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineTextBold);
export default __webpack_public_path__ + "static/media/vuesax-outline-text-bold.89080009d5d5c830779c11df2e9e216c.svg";
export { ForwardRef as ReactComponent };